<template>
  <div class="ml-0 block">
    <h1 class="h2 mb-3">Committee Members List</h1>
    <div class="text-center p-2" v-if="isLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="!isLoading">
      <div role="alert" class="alert alert-success" v-if="success">{{ success }}</div>
      <div role="alert" class="alert alert-warning" v-if="errors">{{ errors }}</div>
      <div class="row">
        <div class="col-12 form-group">
          <p v-for="member in currentCommitteeMembers" :key="member.id">
            <span class='col-12 row ml-0'> {{ member.first_name + ' ' + member.last_name }} </span>
            <span class='badge row ml-3 alert-success' v-for="status in member.committee_membership_statuses"
                  :key="status.id">
                {{ status.name }}
              </span>
            <span class="col-12 row ml-0">
                    <a href="#" @click.prevent="setSingleMemberEdit(member.id)" :disabled="processing">Edit</a>
                    <a class="ml-2" href="#" @click.prevent="removeCommitteeMemberStatus(member.id)">Remove</a>
                </span>
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5 col-lg-5 col-12 form-group button-add-committee-member-wrapper">
          <button
            :class="['btn btn-block button-add-committee-member', processing ? 'btn-primary-dark' : 'btn-primary']"
            @click.prevent="showModal = true" :disabled="processing">
            {{ processing ? '' : 'Add Member' }}
            <div v-if="processing" class="spinner-border text-light" role="status"><span
              class="sr-only">Loading...</span></div>
          </button>
        </div>
      </div>
    </div>

    <!-- use the modal component, pass in the prop -->
    <modal v-if="showModal" @close="showModal = false">
      <h3 slot="header" class="modal-title">Add a Member</h3>
      <div slot="body">
        <div class="row">
          <div class="col-12 col-md-12 form-group">
            <vue-bootstrap-typeahead
              :data="foundCommitteeMembers"
              v-model="searchMember"
              :serializer="s => s.first_name + ' ' + s.last_name"
              placeholder="Start typing..."
              @hit="selectedMember = $event"
            />
          </div>
        </div>

        <div class="row">
          <div class="table-responsive">
            <table class="table table-striped table-bordered border-0">
              <thead>
              <tr>
                <th class="position-relative">Name</th>
                <th class="position-relative">Email</th>
                <th class="position-relative">Status</th>
                <th class="position-relative"></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="member in committeeMembers" :key="member.id">
                <td>{{ member.first_name + ' ' + member.last_name }}</td>
                <td>{{ member.attributes.email }}</td>
                <td>
                  <form :id="`form_${member.id}`">
                    <ul class="col-12 member-status-list">
                      <li v-for="status in statusesList" :key="status.id">
                        <div class="member-status-item">
                          <input type="checkbox" :disabled="currentMembersIds.includes(member.id)"
                                 :value="status.id" v-model="checkedStatuses[member.id]"
                                 :name="`status[${member.id}]`" :id="`status_${member.id}${status.id}`">
                          <label :for="`status_${member.id}${status.id}`" class="mb-0">{{ status.name }}</label>
                        </div>
                      </li>
                    </ul>
                  </form>
                </td>
                <td>
                  <p v-if="currentMembersIds.includes(member.id)">Added</p>
                  <a v-else @click.prevent="saveCommitteeMemberStatus(member.id)" href="#">Add to List</a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </modal>

    <modal v-if="singleMemberModal" @close="singleMemberModal = false">
      <h3 slot="header" class="modal-title">Edit Member</h3>
      <div slot="body" class="text-center">
        <div class="row">
          <div class="table-responsive">
            <table class="table table-striped table-bordered table-responsive border-0">
              <thead>
              <tr>
                <th class="position-relative">Name</th>
                <th class="position-relative">Email</th>
                <th class="position-relative">Status</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{ singleMemberEdit.first_name + ' ' + singleMemberEdit.last_name }}</td>
                <td>{{ singleMemberEdit.attributes.email }}</td>
                <td>
                  <form :id="`edit_form_${singleMemberEdit.id}`">
                    <ul class="member-status-list">
                      <li v-for="status in statusesList" :key="status.id">
                        <input type="checkbox" :value="status.id"
                               v-model="singleMemberEditStatuses[singleMemberEdit.id]"
                               :name="`status[${singleMemberEdit.id}]`"
                               :id="`edit_status_${singleMemberEdit.id}${status.id}`">
                        <label :for="`edit_status_${singleMemberEdit.id}${status.id}`" class="mb-0">{{
                            status.name
                          }}</label>
                      </li>
                    </ul>
                  </form>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="col-12 d-flex justify-content-center">
          <button class="btn btn-outline-primary ml-2" @click.prevent="singleMemberModal = false">Cancel</button>
          &nbsp;
          <button class="btn btn-primary"
                  @click.prevent="singleMemberModal = false;saveCommitteeMemberStatus(singleMemberEdit.id, 'edit_')">
            Save
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import _ from "lodash"
import axios from 'axios'
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import modal from '@/components/Modal'

export default {
  name: 'CommitteeDetailsMembersStatus',
  props: ['committeeId'],
  components: {
    modal,
    VueBootstrapTypeahead
  },
  beforeMount() {
    this.getCommitteeMemberStatuses()
  },
  computed: {
    currentMembersIds() {
      const ids = []
      this.currentCommitteeMembers.forEach((member) => {
        ids.push(member.id)
      })

      return ids
    }
  },
  data() {
    return {
      errors: '',
      checkedStatuses: [],
      committeeMembers: [],
      currentCommitteeMembers: [],
      formDataCheckboxes: [],
      foundCommitteeMembers: [],
      processing: false,
      searchMember: '',
      selectedMember: [],
      showModal: false,
      singleMemberEdit: [],
      singleMemberEditStatuses: [],
      singleMemberModal: false,
      success: '',
      statusesList: [],
      committeeDetails: null,
      isLoading: true
    }
  },
  methods: {
    checkMemberStatuses() {
      this.checkedStatuses = []
      this.committeeMembers.forEach((member) => {
        if (!this.checkedStatuses[member.id]) {
          this.checkedStatuses[member.id] = []
        }
        member.committee_membership_statuses.forEach((checked) => {
          this.checkedStatuses[member.id].push(checked.id)
        })
      })
      this.getCurrentCommitteeMembers()
    },
    getCommitteeMemberStatuses() {
      axios.get(`${this.$api}/committee/memberStatusList`).then((response) => {
        this.statusesList = response.data.statuses
      })
    },
    getCurrentCommitteeMembers() {
      axios.get(`${this.$api}/admin/committee/currentMembers/${this.committeeDetails.id}`).then((response) => {
        if (response.data.status === 'success') {
          this.errors = ''
          this.currentCommitteeMembers = response.data.members
        } else {
          this.errors = 'Something went wrong. Please reload the page.'
        }
      })
    },
    removeCommitteeMemberStatus(member_id) {
      axios.post(`${this.$api}/admin/committees/save-member-status`, { params: { user_id: member_id, statuses: [] } }).then((response) => {
        if (response.data.status === 'success') {
          this.getCurrentCommitteeMembers()
        }
      })
    },
    saveCommitteeMemberStatus(member_id, edit = '') {
      const form = document.getElementById(`${edit}form_${member_id}`)
      const checkboxes = form.querySelectorAll('input[type=checkbox]:checked')
      this.formDataCheckboxes = []

      checkboxes.forEach((element) => {
        this.formDataCheckboxes.push({
          committee_id: this.committeeDetails.id,
          user_id: member_id,
          status_id: element.value
        })
      })

      axios.post(`${this.$api}/admin/committees/save-member-status`, { params: { user_id: member_id, statuses: this.formDataCheckboxes } }).then((response) => {
        if (response.data.status === 'success') {
          this.getCurrentCommitteeMembers()
          this.success = "The member has been updated."
        }
      })
    },
    searchCommitteeMember(search_term, isSearch = false) {
      if (!search_term) {
        this.committeeMembers = []
      } else {
        axios.get(`${this.$api}/admin/committees/member-search`, { params: { searchMember: search_term } }).then((response) => {
          if (response.data.status === 'success') {
            this.errors = ''
            if (isSearch) {
              this.committeeMembers = response.data.members
              this.checkMemberStatuses()
            } else {
              this.foundCommitteeMembers = response.data.members
            }
          } else {
            this.errors = 'Something went wrong. Please reload the page.'
          }
        })
      }
    },
    selectMember(selected) {
      this.committeeMembers = []
      this.committeeMembers.push(selected)
      this.checkMemberStatuses()
    },
    setSingleMemberEdit(member_id) {
      this.singleMemberEdit = []
      this.singleMemberEditStatuses = []

      this.currentCommitteeMembers.forEach((member) => {
        if (member.id === member_id) {
          this.singleMemberEdit = member
          this.singleMemberEditStatuses[member.id] = []
          member.committee_membership_statuses.forEach((checked) => {
            this.singleMemberEditStatuses[member.id].push(checked.id)
          })
        }
      })

      this.singleMemberModal = true
    },
    getCommittee(id) {
      axios.get(`${this.$api}/admin/committee-details/${id}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.committeeDetails = response.data.data
            this.isLoading = false
          }
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.isLoading = false
        })
    }
  },
  mounted() {
    this.getCommittee(this.committeeId)
  },
  watch: {
    committeeDetails() {
      this.getCurrentCommitteeMembers()
    },
    // eslint-disable-next-line func-names
    searchMember: _.debounce(function (value) {
      this.searchCommitteeMember(value)
    }, 500),
    // eslint-disable-next-line func-names
    selectedMember: _.debounce(function (value) {
      this.selectMember(value)
    }, 500)
  }
}
</script>

<style scoped>
.member-status-list {
  text-align: left;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Committees/Edit/components/CommitteeDetailsMembersStatus.vue